import back from 'assets/back-button-white.svg'

import {useUser} from 'features/authorized/context/user'
import LanguageSelect from './components/LanguageSelect'

const OnboardingPageHeader = ({onClickBack}: {onClickBack: () => void}) => {
    const {user} = useUser()
    return (
        <div className="relative flex flex-1 justify-between py-3 px-4">
            <div className="flex items-center">
                <button onClick={onClickBack}>
                    <img src={back} alt="back" />
                </button>
            </div>
            <div className="flex items-center justify-center text-lg font-bold text-white">
                {user ? user.organization.name : ''}
            </div>
            <div className="flex items-center justify-center text-white">
                <LanguageSelect />
            </div>
        </div>
    )
}

export default OnboardingPageHeader
